// import React,{Component} from "react";

// // reactstrap components
// import {
//   Col,
//   Progress,
//   Label,
//   Button,
//   Input
// } from "reactstrap";
// import {base,s3base} from "api.js";
// import { Checkbox } from '@mui/material';
// import Sound from 'react-sound';
// // core components
// import "components/custom.css";
// import ReactHtmlParser from 'react-html-parser';
// import reactStringReplace from 'react-string-replace';
// import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
// import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";

// class ListeningBlank extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isRecording: false,
//       blobURL: '',
//       isBlocked: false,
//       question:"",
//       secondCount:10,
//       recordCount:0,
//       recordId:1,
//       intervalId:0,
//       questionId:"",
//       reset:false,
//       soundStatus:true,
//       selectedValue:'',
//       soundPer:0,
//       volume:100,
//       correctFlag:true,
//       resultObj:{},
//       stopped: false,
//       playbackSpeed: 1,
//       soundKey: 0,
//       question_audio: null,
//       defaultSelectedVoice: null
//     };
//   }
//   componentDidMount() {
//     if (!this.props.answer) {
//       // select audio.
//       let question_audio = null;
//       let defaultSelectedVoice = null;

//       if ('question_audios' in this.props.data && this.props.data.question_audios.length > 0) {
//         let x = parseInt(Math.random() * 6);

//         const { question_audios } = this.props.data;
//         question_audio = `${s3base}/${question_audios[x].value}`;
//         defaultSelectedVoice = question_audios[x].label;
//       } else {
//         const { media_link } = this.props.data;
//         question_audio = `${s3base}${media_link}`;
//       }

//       var intervalId = setInterval(this.timer, 1000);
//       this.setState({
//         intervalId,
//         question_audio,
//         defaultSelectedVoice
//       });
//     }
//   }

//   stopTest = () =>{
//     this.props.nextQuestion(this.state.resultObj);
//   }

//   static getDerivedStateFromProps(props, state) {
//     if (props.data) {
//       if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//         clearInterval(state.intervalId);
//         clearInterval(state.recordId);

//         let question_audio = null;
//         let defaultSelectedVoice = null;
//         if ('question_audios' in props.data && props.data.question_audios.length > 0) {
//           let x = parseInt(Math.random() * 6);

//           const { question_audios } = props.data;
//           question_audio = `${s3base}/${question_audios[x].value}`;
//           defaultSelectedVoice = question_audios[x].label;
//         } else {
//           const { media_link } = props.data;
//           question_audio = `${s3base}${media_link}`;
//         }

//         [...document.querySelectorAll('.blankBox')].map((q) => { q.value=""; });
//         return {
//           correctFlag: true,
//           recordCount: 0,
//           soundPer: 0,
//           isRecording: false,
//           secondCount: 10,
//           questionId: props.data.id,
//           blobURL: '',
//           reset: true,
//           soundStatus: true,
//           question_audio,
//           defaultSelectedVoice
//         };
//       }else{
//         if (!state.questionId) {
//           return {correctFlag:true,questionId: props.data.id};
//         }
//       }

//       }
//   }

//   timer = () => {
//     if (this.state.secondCount === 1) {
//       clearInterval(this.state.intervalId);

//     }
//     this.setState({ secondCount: this.state.secondCount -1 });
//   }

//   handleSongFinishedPlaying = () => {
//     this.setState({'soundStatus':false});
//     this.props.soundChecked();

//   }



//   timerRecord = () => {
//     if (this.state.recordCount === 40) {
//       clearInterval(this.state.recordId);
//       this.stop();
//     }
//     this.setState({ recordCount: this.state.recordCount + 1 });
//   }

//   handleChange = (event) => {
//     this.props.showResult();
//     let arr = [];
//     [...document.querySelectorAll('.blankBox')].map((q) => { arr.push(q.value); });
//     let correct = this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v,k) => { if (k%2 == 1) { return v.trim(); } });
//     this.props.submit({'answer':arr,'correct':correct},true);
//     this.setState({resultObj:{'answer':arr,'correct':correct}})
//   };

//   updateCorrect = () =>{
//     let correct = this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v,k) => { if (k%2 == 1) { return v.trim(); } });
//     this.props.submit({'answer':[],'correct':correct});
//     this.setState({correctFlag:false,resultObj:{'answer':[],'correct':correct}});
//   }

//   showAnswer = () => {


//       if (!this.props.resultMode) {
//         let elem = document.querySelectorAll('.checkedSign');
//         for (var i = 0; i <= elem.length-1; i++) {
//           let id = elem[i].dataset.id;

//           if (elem[i].dataset.text.trim() == document.getElementById(id).value.trim()) {
//             elem[i].innerHTML= '<i className="fa fa-check" style="font-size:32px;color:green"></i>';
//           }else{
//             elem[i].innerHTML = '<i className="fa fa-times" style="font-size:32px;color:red"></i>';

//           }
//         }
//       }

//   }

//   componentWillUnmount = () => {
//     clearInterval(this.state.intervalId);
//   }

//   handleSongPlaying = (obj) => {
//     this.setState({soundPer:obj.position*100/obj.duration});
//   }

//   changeRange = (e) => {
//       this.setState({volume: e.target.value});
//   }

//   skip = () => {
//     clearInterval(this.state.intervalId);
//     this.setState({secondCount:0});
//   };

//   changePlaybackSpeed = (speed) => {
//     this.setState((prevState) => ({
//       soundKey: prevState.soundKey + 1
//     }));
//     this.setState({playbackSpeed: speed});
//   }


//   changeAudio = (selected) => {
//     clearInterval(this.state.intervalId2);
    
//     this.setState({
//       intervalId2: 0
//     }, () => {
      
//       const { question_audios } = this.props.data;
//       const selected_audio = question_audios.filter((audio, i) => {
//         return audio.label === selected.label;
//       });

//       this.setState({
//         question_audio: `${s3base}/${selected_audio[0].value}`
//       });
//     });
//   }

//   render() {
//     let question ="";
//     let correct ="";
//     if (this.props.restart) {
//       this.props.restartQue();
//     }

//     if (this.props.answer) {
//       this.showAnswer();
//     }

//     if (this.props.stopRecording) {
//       this.stopTest();
//     }


//     /**
//     * IMPORTANT
//     * 1. in case of timeout secondCount condition will work.
//     * 2. in case of next button clicked by user ELSE IF condition will work.
//     */
//     // console.log('secondcount::', this.props.secondCount);
//     // if (!this.state.stopped && this.props.secondCount === 1) {
//     //   console.log('secondcount == 1');
//     //   this.setState({ stopped: true }, () => {
//     //     console.log('Stopping test by secondCount');
//     //     this.stopTest();
//     //   });
//     // } else if (!this.state.stopped && this.props.stopRecording) {
//     //   console.log('stopRecording');
//     //   this.setState({ stopped: true }, () => {
//     //     console.log('Stopping test by stopRecording');
//     //     this.stopTest();
//     //   });
//     // }
//     /** ----------------------------------------------------------------- */

//     if (this.props.data) {
//       question = this.props.data.question;
//       correct = question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v,k) => { if (k%2 == 1) { return v.trim(); } });
//       if (this.state.correctFlag) {
//         this.updateCorrect();
//       }
//     }
//     if (this.state.reset) {
//       var intervalId = setInterval(this.timer, 1000);
//       this.setState({intervalId: intervalId,reset:false});
//     }

//     return (
//       <>
//         <Col xs={12}>
//           <h4 className="infoText">
//           </h4>
//         </Col>
//         {!this.props.resultMode &&
//           <Col xs={12}>
//             <div className="col-lg-12 text-center">
//               <div className="currentStatus">
//                 <div>Current Status:{this.state.soundStatus == true && this.state.secondCount !== 0 && !this.state.isRecording && ' Begining in '+this.state.secondCount+ ' seconds'}
//                   {this.state.secondCount == 0 && this.state.blobURL === '' && !this.state.isRecording && ' Playing'}

//                   <br></br>
//                   Volume
//                   <Input placeholder="Volume" type="range" min="0" defaultValue={this.state.volume} step="1" onInput={(e) => this.changeRange(e)} max="100"  />
//                   <br></br>
                  
//                   <Progress color="info" value={(this.state.soundPer)} />
//                   {!this.props.testMode && (
//                     <div className="d-flex justify-content-between">
//                       <div className='stop-btn'>
//                         {this.state.secondCount!==0 && this.state.blobURL === '' && !this.state.isRecording &&
//                           <Button color="success" onClick={this.skip} size="sm">Skip</Button>
//                         }
//                       </div>
//                       <div className="stop-btn clearfix">
//                         <div className="select-voice pull-left">
//                           {this.state.defaultSelectedVoice !== null &&
//                             <SelectVoiceDropDown
//                               voices={this.props.voices}
//                               selected={this.state.defaultSelectedVoice}
//                               changeAudio={this.changeAudio}
//                             />
//                           }
//                         </div>
//                         <div className="select-speed pull-right">
//                           <PlaybackSpeedBtns
//                             changePlaybackSpeed={this.changePlaybackSpeed}
//                             playbackSpeed={this.state.playbackSpeed}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <Col xs={12}>
//                 {this.props.data && !this.props.resultMode && this.state.soundStatus && this.state.secondCount === 0 &&
//                   <Sound
//                     url={this.state.question_audio}
//                     playStatus={Sound.status.PLAYING}
//                     onFinishedPlaying={this.handleSongFinishedPlaying}
//                     onPlaying={this.handleSongPlaying}
//                     volume={this.state.volume}
//                     playbackRate={this.state.playbackSpeed}
//                     key={this.state.soundKey}
//                   />
//                 }
//               </Col>
//               <Col xs={12}>
//                 <>
//                   {this.state.blobURL &&
//                     <audio src={this.state.blobURL} controls="controls" />
//                   }
//                 </>
//               </Col>
//             </div>
//           </Col>
//         }

//         <Col xs={12}>
//           <h5>{this.props.data && !this.props.resultMode && reactStringReplace(question.replace(/<[^>]*>?/gm, 'x_x').replace(/x_x(.*?)x_x/g,''), /(__add_blank__)/g, (match, i, o) => (<>
//               <input type="text" id={i} spellCheck="false" autocomplete="off" onChange={(e) => { this.handleChange(e)} } className="blankBox" />{this.props.answer && <span><span className="checkedSign" style={{display: (this.props.answer)?"inline-block":"none"}} data-id={i} data-text={correct[(i-1)/2]} ></span><span className="correct" >{correct[(i-1)/2]}</span></span>}</>
//             ))}
//           </h5>
//         </Col>

//         <Col xs={12}>&nbsp;</Col>
//         <Col xs={12}>&nbsp;</Col>
//         <Col xs={12}>
//           {this.props.data && this.props.resultMode &&
//             <h4>Correct answer</h4>
//           }
//           <h5>{this.props.data && this.props.resultMode && ReactHtmlParser(question.replace(/<span[^>]*>?/g, '<b className="correct">').replace(/<[^>]*span>?/g, '</b>&nbsp;').replace(/__add_blank__/g, '')) }</h5>
//         </Col>
//         <Col xs={12}>
//           {this.props.data && this.props.resultMode &&
//             <h4>Your response</h4>
//           }
//           <h5>{this.props.data && this.props.resultMode && ReactHtmlParser(question.replace(/<span[^>]*>?/g, '<b className="selected-option">').replace(/<[^>]*span>?/g, '</b>&nbsp;').replace(/__add_blank__/g, '')) }</h5>
//         </Col>
//       </>
//     );
//   }
// }

// export default ListeningBlank;

import React, { useState, useEffect, useRef } from "react";
import {Col , ProgressBar , Form , Button} from "react-bootstrap";
import { base, s3base } from "api.js";
import { Checkbox } from '@mui/material';
import Sound from 'react-sound';
// core components
import "components/custom.css";
import ReactHtmlParser from 'react-html-parser';
import reactStringReplace from 'react-string-replace';
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
import { formatTimeMiliSecond } from "util/helper.js";

const ListeningBlank = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [intervalId2, setIntervalId2] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [selectedValue, setSelectedValue] = useState('');
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(100);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [stopped, setStopped] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [question_audio, setQuestion_audio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [remainingTime, setRemainingTime] = useState("00:00");
  const [audioRetryCount, setAudioRetryCount] = useState(0);
  const [audioFailed, setAudioFailed] = useState(false);
  const MAX_AUDIO_RETRIES = 1;

  const prevPropsRef = useRef();
  const intervalIdRef = useRef(null);
  const lastSoundPerRef = useRef(0);
  const lastSoundPerTimeRef = useRef(null);
  const stallWatchdogRef = useRef(null);
  const STALL_TIMEOUT_MS = 5000;

  // ComponentDidMount
  useEffect(() => {
    if (!props.answer) {
      // select audio.
      let questionAudio = null;
      let defaultVoice = null;

      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);

        const { question_audios } = props.data;
        questionAudio = `${s3base}/${question_audios[x].value}`;
        defaultVoice = question_audios[x].label;
      } else {
        const { media_link } = props.data;
        questionAudio = `${s3base}${media_link}`;
      }

      const newIntervalId = setInterval(timer, 1000);
      intervalIdRef.current = newIntervalId;
      setIntervalId(newIntervalId);
      setQuestion_audio(questionAudio);
      setDefaultSelectedVoice(defaultVoice);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    const prevProps = prevPropsRef.current;
    
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalId);
        clearInterval(recordId);

        let questionAudio = null;
        let defaultVoice = null;
        if ('question_audios' in props.data && props.data.question_audios.length > 0) {
          let x = parseInt(Math.random() * 6);

          const { question_audios } = props.data;
          questionAudio = `${s3base}/${question_audios[x].value}`;
          defaultVoice = question_audios[x].label;
        } else {
          const { media_link } = props.data;
          questionAudio = `${s3base}${media_link}`;
        }

        [...document.querySelectorAll('.blankBox')].map((q) => { q.value = ""; });
        
        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setIsRecording(false);
        setSecondCount(10);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setSoundStatus(true);
        setQuestion_audio(questionAudio);
        setDefaultSelectedVoice(defaultVoice);
        setAudioRetryCount(0);
        setAudioFailed(false);
        if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; }
        lastSoundPerRef.current = 0;
        lastSoundPerTimeRef.current = null;
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }

    prevPropsRef.current = props;
  }, [props.data, props.restart, questionId]);

  const timer = () => {
    setSecondCount((prev) => {
      if (prev <= 1) {
        clearInterval(intervalIdRef.current);
        return 0;
      }
      return prev - 1;
    });
  };

  const handleSongFinishedPlaying = () => {
    if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; }
    setSoundStatus(false);
    props.soundChecked();
  };

  const handleAudioError = (err) => {
    console.error('Audio playback error:', err);
    if (audioRetryCount < MAX_AUDIO_RETRIES) {
      setSoundStatus(false);
      setSoundPer(0);
      setAudioRetryCount(prev => prev + 1);
      setTimeout(() => { setSoundKey(prev => prev + 1); setSoundStatus(true); }, 300);
    } else {
      setAudioFailed(true);
      setSoundStatus(false);
      props.soundChecked();
    }
  };

  useEffect(() => {
    if (soundStatus && secondCount <= 0 && !audioFailed) {
      lastSoundPerRef.current = 0;
      lastSoundPerTimeRef.current = Date.now();
      stallWatchdogRef.current = setInterval(() => {
        const timeSinceProgress = Date.now() - (lastSoundPerTimeRef.current || Date.now());
        if (timeSinceProgress > STALL_TIMEOUT_MS && lastSoundPerRef.current > 0) {
          clearInterval(stallWatchdogRef.current);
          stallWatchdogRef.current = null;
          handleAudioError({ type: 'stall' });
        }
      }, 1000);
    }
    return () => { if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; } };
  }, [soundStatus, secondCount, audioFailed]);

  const timerRecord = () => {
    setRecordCount((prev) => {
      if (prev === 40) {
        clearInterval(recordId);
        stop();
      }
      return prev + 1;
    });
  };

  const handleChange = (event) => {
    props.showResult();
    let arr = [];
    [...document.querySelectorAll('.blankBox')].map((q) => { arr.push(q.value); });
    let correct = props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => { if (k % 2 == 1) { return v.trim(); } });
    props.submit({ 'answer': arr, 'correct': correct }, true);
    setResultObj({ 'answer': arr, 'correct': correct });
  };

  const updateCorrect = () => {
    let correct = props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => { if (k % 2 == 1) { return v.trim(); } });
    props.submit({ 'answer': [], 'correct': correct });
    setResultObj({ 'answer': [], 'correct': correct });
    setCorrectFlag(false);
  };

  const showAnswer = () => {
    if (!props.resultMode) {
      let elem = document.querySelectorAll('.checkedSign');
      for (var i = 0; i <= elem.length - 1; i++) {
        let id = elem[i].dataset.id;

        if (elem[i].dataset.text.trim() == document.getElementById(id).value.trim()) {
          elem[i].innerHTML = '<i className="fa fa-check" style="font-size:32px;color:green"></i>';
        } else {
          elem[i].innerHTML = '<i className="fa fa-times" style="font-size:32px;color:red"></i>';
        }
      }
    }
  };

  const handleSongPlaying = (obj) => {
    const newPer = obj.position * 100 / obj.duration;
    // if (newPer > 10) return; // stop updating progress after 10%
    setSoundPer(newPer);
    setRemainingTime(formatTimeMiliSecond(obj.duration - obj.position));
    if (newPer !== lastSoundPerRef.current) {
      lastSoundPerRef.current = newPer;
      lastSoundPerTimeRef.current = Date.now();
    }
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const skip = () => {
    clearInterval(intervalId);
    setSecondCount(0);
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey((prevKey) => prevKey + 1);
    setPlaybackSpeed(speed);
  };

  const changeAudio = (selected) => {
    clearInterval(intervalId2);
    
    setIntervalId2(0);
    
    const { question_audios } = props.data;
    const selected_audio = question_audios.filter((audio, i) => {
      return audio.label === selected.label;
    });

    setQuestion_audio(`${s3base}/${selected_audio[0].value}`);
  };

  const stopTest = () => {
    props.nextQuestion(resultObj);
  };

  // Effect for reset
  useEffect(() => {
    if (reset) {
      const newIntervalId = setInterval(timer, 1000);
      intervalIdRef.current = newIntervalId;
      setIntervalId(newIntervalId);
      setReset(false);
    }
  }, [reset]);

  // Handle answer display
  useEffect(() => {
    if (props.answer) {
      showAnswer();
    }
  }, [props.answer]);

  // Handle stop recording
  useEffect(() => {
    if (props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording]);

  // Handle restart
  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);

  let questionText = "";
  let correct = "";

  if (props.data) {
    questionText = props.data.question;
    // console.log(props)
    correct = questionText.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => { if (k % 2 == 1) { return v.trim(); } });
    if (correctFlag) {
      updateCorrect();
    }
  }


  return (
    <>
      <Col xs={12}>
        <h4 className="infoText">
        </h4>
      </Col>
      {!props.resultMode &&
        <Col xs={12}>
          <div className="col-lg-12 text-center">
            <div className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section">
              <div className="w-100 text-white p-4">
                {/* Current Status:{soundStatus == true && secondCount !== 0 && !isRecording && ' Begining in ' + secondCount + ' seconds'}
                {secondCount == 0 && blobURL === '' && !isRecording && ' Playing'} */}

                {/* <br></br>
                Volume
                <Input placeholder="Volume" type="range" min="0" defaultValue={volume} step="1" onInput={(e) => changeRange(e)} max="100" />
                <br></br>

                <Progress color="info" value={(soundPer)} /> */}

                <div className="d-flex justify-content-end w-100 align-items-center" style={{ minHeight: "20px" }}>
                {secondCount <= 0 && blobURL === "" && !isRecording && (
                    <p className="mb-0 fs-10">{remainingTime}</p>
                  )}
                </div>
                <div className="d-flex justify-content-center align-content-center w-100 gap-3 py-1">
                  <i className="fa fa-play" aria-hidden="true"></i>
                  <div className="flex-grow-1">
                    <ProgressBar
                      style={{ backgroundColor: "#e9ecef", height: "15px" }}
                      barStyle={{ backgroundColor: "#4493e0" }}
                      now={(soundPer)}
                    />
                    {/* <Progress color="info" value={(soundPer)} /> */}
                  </div>
                </div>
                <div className="d-flex justify-content-start w-100 align-items-center" style={{ minHeight: "20px" }} >
                  {soundPer === 100 ? (
                    <p className="mb-0 fs-10 mx-4">Completed</p>
                  ) : soundStatus === true &&
                    secondCount >= 0 &&
                    !isRecording ? (
                    <p className="mb-0 fs-10 mx-4">
                      The clip will begin in {secondCount} seconds
                    </p>
                  ) : (
                    <p className="mb-0 fs-10 mx-4 invisible"></p>
                  )}
                </div>
                <br></br>
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <div className="d-flex justify-content-center gap-3  align-items-center w-50">
                    <i className="fa fa-volume-up" aria-hidden="true"></i>
                    <Form.Control
                      placeholder="Volume"
                      type="range"
                      min="0"
                      defaultValue={volume}
                      step="1"
                      onInput={(e) => changeRange(e)}
                      max="100"
                    />
                  </div>
                </div>                

                {!props.testMode && (
                  <div className="d-flex justify-content-between">
                    <div className='stop-btn'>
                      {secondCount !== 0 && blobURL === '' && !isRecording &&
                        <Button variant="success" onClick={skip} size="sm">Skip</Button>
                      }
                    </div>
                    <div className="stop-btn clearfix">
                      <div className="select-voice pull-left">
                        {defaultSelectedVoice !== null &&
                          <SelectVoiceDropDown
                            voices={props.voices}
                            selected={defaultSelectedVoice}
                            changeAudio={changeAudio}
                          />
                        }
                      </div>
                      <div className="select-speed pull-right">
                        <PlaybackSpeedBtns
                          changePlaybackSpeed={changePlaybackSpeed}
                          playbackSpeed={playbackSpeed}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <Col xs={12}>
              {props.data && !props.resultMode && soundStatus && secondCount <= 0 &&
                <Sound
                  url={question_audio}
                  playStatus={Sound.status.PLAYING}
                  onFinishedPlaying={handleSongFinishedPlaying}
                  onPlaying={handleSongPlaying}
                  onError={handleAudioError}
                  volume={volume}
                  playbackRate={playbackSpeed}
                  key={soundKey}
                />
              }
            </Col>
            <Col xs={12}>
              <>
                {blobURL &&
                  <audio src={blobURL} controls="controls" />
                }
              </>
            </Col>
          </div>
        </Col>
      }

      <Col xs={12}>
        <h5>{props.data && !props.resultMode && reactStringReplace(questionText.replace(/<[^>]*>?/gm, 'x_x').replace(/x_x(.*?)x_x/g, ''), /(__add_blank__)/g, (match, i, o) => (<>
          <input type="text" id={i} spellCheck="false" autocomplete="off" onChange={(e) => { handleChange(e) }} className="blankBox" />{props.answer && <span><span className="checkedSign" style={{ display: (props.answer) ? "inline-block" : "none" }} data-id={i} data-text={correct[(i - 1) / 2]} ></span><span className="correct" >{correct[(i - 1) / 2]}</span></span>}</>
        ))}
        </h5>
      </Col>

      {
        !props.resultMode && <>
      <Col xs={12}>&nbsp;</Col>
      <Col xs={12}>&nbsp;</Col>
      </>}
      <Col xs={12}>
        {props.data && props.resultMode &&
          <h5>Correct answer</h5>
        }
        <p className={props.resultMode ? "reading-text text-start" : "question"}>{props.data && props.resultMode && ReactHtmlParser(questionText.replace(/<span[^>]*>?/g, '<b className="correct">').replace(/<[^>]*span>?/g, '</b>&nbsp;').replace(/__add_blank__/g, ''))}</p>
      </Col>
      {/* <Col xs={12}>
        {props.data && props.resultMode &&
          <h4>Your response</h4>
        }
        <h5>{props.data && props.resultMode && ReactHtmlParser(questionText.replace(/<span[^>]*>?/g, '<b className="selected-option">').replace(/<[^>]*span>?/g, '</b>&nbsp;').replace(/__add_blank__/g, ''))}</h5>
     
      </Col> */}
      <Col xs={12}>
  {/* {props.data && !props.resultMode &&
    <h4>Your response</h4>
  } */}
  {/* <h5>{props.data && !props.resultMode && (() => {
    const userAnswers = props.data.answer ? props.data.answer.split(',') : [];
    return ReactHtmlParser(questionText.replace(/<span[^>]*>?/g, '<b class="selected-option">').replace(/<[^>]*span>?/g, '</b>&nbsp;').replace(/__add_blank__/g, '').replace(/<b class="selected-option"><\/b>/g, (match, offset, string) => {
      const index = string.substring(0, offset).split('<b class="selected-option"></b>').length - 1;
      return `<b class="selected-option">${userAnswers[index] || '-'}</b>`;
    }));
  })()}</h5> */}
</Col>
    </>
  );
};

export default ListeningBlank;